import React from 'react';
import { modelClass } from '/imports/api/escrows';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const EscrowPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'tradeno', label: 'Trade Number' }], [{ field: 'closed', label: 'Closed' }], [{ field: 'completed', label: 'Completed' }]]}
  />
);
